import { AxiosResponse } from "axios";
import { IApiResponse } from "../../../@types/api-response.type";
import { IArea } from "../../../@types/area.type";
import { IGrid } from "../../../@types/grid.type";
import { Api } from "../ApiConfig"
import { ApiException } from "../ApiException"
import { IReportMetricsBody } from "../../../@types/reports-metrics.type";
import { IAreaFilterRequest } from "../../../@types/area-filter-request.type";
import { downloadExcel } from "../../../utils/download";
import { getErrorMessage } from "../../../utils/utils";

export const searchAreas = async (areafilter: IAreaFilterRequest) : Promise<IApiResponse<IGrid<IArea>> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<IGrid<IArea>>>(`/api/Area/SearchAreas`, areafilter);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Área'))
    }
}

export const getAreaById = async (id: string) : Promise<IApiResponse<IArea> | ApiException> => {
    try {
        const { data } = await Api.get<IApiResponse<IArea>>(`/api/Area/GetAreaById?areaId=${id}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar Área por Id'))
    } 
}

export const addOrUpdateArea = async (area: IArea) :  Promise<void> => {
    try {
        await Api.post<AxiosResponse<void>>("/api/Area/AddOrUpdateArea", area);
    } catch (error) {
        const message = 'Erro ao criar ou atualizar Área';
        throw new ApiException(getErrorMessage(error, message));
    } 
};

export const deleteArea = async (id: string) => {
    try {
        await Api.delete(`/api/Area/DeleteArea/${id}`);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar Área'))
    } 
};

export const getAllAreasIdsAndNames = async () => {
    try {
        const { data } = await Api.get(`/api/Area/GetAllAreasIdsAndNames`)
        return data.result
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todas Áreas'))
    } 
}

export const getAreasMetrics = async (area: IReportMetricsBody) => {
    try {
        const { data } = await Api.post("/api/Area/GetAreasMetrics",
        {"id": area.id, "startTime": area.startTime, 
        "endTime": area.endTime, "timeType": area.timeType});
        return data;
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao consultar metricas da Área'))
    } 
}

export const downloadAreasReportToExcel = async (filters: IReportMetricsBody) : Promise<void> => {
    try {
        const response = await Api.post(
            `/api/Area/DownloadAreasReportToExcel`, 
            filters  , { responseType: "blob" });

        downloadExcel("Relatorio-Area", response.data);
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar os Projeto'))
    }    
}

export const AreasService = {
    searchAreas,
    getAreaById,
    addOrUpdateArea,
    deleteArea,
    getAreasMetrics,
    getAllAreasIdsAndNames,
    downloadAreasReportToExcel,
}